<template>
  <div class="site-multiselect">
    <b-form-group label="Site" class="form-label">
      <multiselect
        v-model="selected"
        @input="updateInput()"
        :options="siteNames"
        track-by="name"
        label="name"
        :searchable="!$feature.mobile"
        selectLabel=""
        deselectLabel=""
        :allowEmpty="false"
        placeholder="Select Site">
      </multiselect>
    </b-form-group>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'SiteDropdown',
  components: {
    Multiselect
  },
  data() {
    return {
      initializedSiteNames: false
    };
  },
  computed: {
    ...mapGetters('savanna/sites', {
      siteNames: 'getSiteNames'
    }),
    ...mapGetters('savanna/sites', {
      selectedSite: 'getSelectedSite'
    }),
    ...mapState('savanna/sites', ['selectedSite']),
    selected: {
      set(selected) {
        this.$store.commit('savanna/sites/setSelectedSite', selected);
      },
      get() {
        return this.selectedSite;
      }
    }
  },
  methods: {
    updateInput() {
      if (this.selected) {
        this.$store.dispatch('localstorage/saveToLocalStorage', { key: 'site', value: this.selected });
      } else {
        this.$store.dispatch('localstorage/removeFromLocalStorage', { key: 'site' });
      }
    },
    getFirstElement() {
      if (this.siteNames.length === 0) return;

      this.selected = this.siteNames[0];
      this.$store.dispatch('localstorage/saveToLocalStorage', { key: 'site', value: this.selected });
    }
  },
  watch: {
    siteNames(names) {
      if (names.length === 0) return;

      if (!this.initializedSiteNames) {
        this.initializedSiteNames = true;
        this.$store.dispatch('localstorage/getFromLocalStorage', { key: 'site' })
          .then((data) => {
            if (data) {
              const found = this.siteNames.find((val) => {
                return val.id === data.id && val.name === data.name;
              });

              if (found) {
                this.selected = data;
              } else {
                this.getFirstElement();
              }
            } else {
              this.getFirstElement();
            }
          });
      } else {
        if (this.selected === null) this.getFirstElement();
      }
    }
  }
};
</script>

<style scoped>
  .form-label {
    font-weight: 600;
    font-size: 0.875rem;
    color: #55595c;
    margin-bottom: 0px;
  }
</style>
<style>
  .site-multiselect .multiselect .multiselect__option--highlight {
    background: #FF9E1B
  }

  .site-multiselect .multiselect .multiselect__option--selected.multiselect__option--highlight {
    background: #FF6A6A
  }

  .site-multiselect .multiselect .multiselect__tags .multiselect__single {
    font-size: 12px;
  }

  .site-multiselect .multiselect {
    font-size: 12px;
  }

  .site-multiselect .multiselect .multiselect__tags .multiselect__input {
    width: 75% !important;
  }

  .sidebar-minimized .sidebar .site-multiselect {
    display: none;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
